// extracted by mini-css-extract-plugin
export default {"logo":"zyCami_logo__8VOMk","logoBox":"zyCami_logoBox__xOi7T","ctn":"zyCami_ctn__Yycpa","functions":"zyCami_functions__8RTd-","button":"zyCami_button__Us12J"};